import {
  dictionariesList,
  adminDictionariesList,
} from "../../pages/Dictionary/Dictionary";

// Map a BE entity SimpleName (the owner-type carried on audit-history rows)
// to the FE-relative path of that entity's detail/edit page. The FE caller
// prepends its role-scoped `startUrl` prefix (/spravce vs /administrator).


const CORE_ENTITY_PATHS = {
  Official:             "/funkcionari/form/{id}",
  Ovm:                  "/podpurne-organy/form/{id}",
  LegitimateAuthority:  "/opravnene-organy/form/{id}",
  FinancialInstitution: "/financni-instituce/form/{id}",
  Initiative:           "/podnety/form/{id}",
  Request:              "/zadosti/form/{id}",
  InternalUser:         "/spravci/{id}",
};

// Per-instance history page per core entity. Used when the owner is soft-
// deleted - clicking the navigation button routes here instead of the dead
// detail page. Dictionaries have no per-instance history page -> not listed,
// and the FE falls back to a disabled "Smazáno" button.
const CORE_ENTITY_HISTORY_PATHS = {
  Official:             "/funkcionari/{id}/historie",
  Ovm:                  "/podpurne-organy/{id}/historie",
  LegitimateAuthority:  "/opravnene-organy/{id}/historie",
  FinancialInstitution: "/financni-instituce/{id}/historie",
  Initiative:           "/podnety/{id}/historie",
  Request:              "/zadosti/{id}/historie",
  InternalUser:         "/spravci/{id}/historie",
};

const DICTIONARY_SEGMENTS = (() => {
  const out = {};
  [...dictionariesList, ...adminDictionariesList].forEach((d) => {
    if (d && d.entityName && d.name) out[d.entityName] = d.name;
  });
  return out;
})();

export const ownerHref = (type, id, startUrl) => {
  if (!type || !id || !startUrl) return null;
  const core = CORE_ENTITY_PATHS[type];
  if (core) return startUrl + core.replace("{id}", id);
  const seg = DICTIONARY_SEGMENTS[type];
  if (seg) return `${startUrl}/ciselniky/${seg}/form/${id}`;
  return null;
};

// History page for a single owner. Returns null when no per-instance history
// page exists for this owner type (e.g. dictionaries) - caller treats null
// as "no fallback destination, leave the button disabled".
export const ownerHistoryHref = (type, id, startUrl) => {
  if (!type || !id || !startUrl) return null;
  const tpl = CORE_ENTITY_HISTORY_PATHS[type];
  if (!tpl) return null;
  return startUrl + tpl.replace("{id}", id);
};
